import { useTranslation as useI18nTranslation } from "react-i18next";

const languageToLocale: Record<string, string> = {
  sk: "sk-SK",
  en: "en-US",
  // Add more mappings as needed
  //cs: 'cs-CZ',
  //de: 'de-DE',
};

export function useTranslation() {
  const { t, i18n } = useI18nTranslation();

  return {
    t: (key: string, options?: any) => t(key, options),
    i18n,
    isSK: i18n.language === "sk",
    isEN: i18n.language === "en",
    locale: languageToLocale[i18n.language] || "en-US", // Fallback to en-US
  };
}
